module.exports = __webpack_public_path__ + "img/gooch-headshot1.764a4c61.jpg";